export default "__VITE_ASSET__BNqXzi_O__"